import icProgramFesta from "@/assets/images/user/icProgramFesta.svg";
import programFesta2026Cont1Img1 from "@/assets/images/user/programFesta2026Cont1Img1.jpg";
import programFesta2026Cont1Img2 from "@/assets/images/user/programFesta2026Cont1Img2.jpg";
import programFesta2026Cont2Img1 from "@/assets/images/user/programFesta2026Cont2Img1.jpg";
import programFesta2026Cont2Img2 from "@/assets/images/user/programFesta2026Cont2Img2.jpg";
// 2025 현장 사진(한국 서브컬처 공모전) - 노출 보류. 현재는 아래 Cont6Img1(공모전 로고)을 쓴다.
// import programFesta2026Cont5Img1 from "@/assets/images/user/programFesta2026Cont5Img1.jpg";
// 파일명은 시안 레이어명(programFestaCont6Img1)을 따랐다. 아코디언 순서(3번째)와는 무관.
// 배경 없는 로고(투명 PNG, 630x275 = 표시 크기 420x183 의 1.5배수).
import programFesta2026Cont6Img1 from "@/assets/images/user/programFesta2026Cont6Img1.png";
// GV2026. 아코디언 순서로는 5번째지만 Cont5(2025 사진)·Cont6(서브컬처 로고)이 이미 쓰여 다음 번호 사용.
// Img1 = 포스터, Img2·Img3 = 세션별 강연자 판(각 990x729, 같은 비율이라 반씩 나눠도 높이가 맞는다).
import programFesta2026Cont7Img1 from "@/assets/images/user/programFesta2026Cont7Img1.jpg";
import programFesta2026Cont7Img2 from "@/assets/images/user/programFesta2026Cont7Img2.jpg";
import programFesta2026Cont7Img3 from "@/assets/images/user/programFesta2026Cont7Img3.jpg";
// 포켓몬 카드 게임 배틀 토너먼트. Img1 = 대회 로고, Img2 = 하단 전체폭 배너.
import programFesta2026Cont8Img1 from "@/assets/images/user/programFesta2026Cont8Img1.jpg";
import programFesta2026Cont8Img2 from "@/assets/images/user/programFesta2026Cont8Img2.jpg";
// 경기게임마이스터고 졸업 작품 전시회 포스터. 세로형(886x1200)이라 표시 폭 420 기준 2배수.
import programFesta2026Cont9Img1 from "@/assets/images/user/programFesta2026Cont9Img1.jpg";
import programStage2026Cont5Img1 from "@/assets/images/user/programStage2026Cont5Img1.jpg";
// import programFestaCont1Img1 from "@/assets/images/user/programFestaCont1Img1.jpg";
// import programFestaCont1Img2 from "@/assets/images/user/programFestaCont1Img2.jpg";
// import programFestaCont2Img1 from "@/assets/images/user/programFestaCont2Img1.jpg";
// import programFestaCont2Img2 from "@/assets/images/user/programFestaCont2Img2.jpg";
// import programFestaCont3Img1 from "@/assets/images/user/programFestaCont3Img1.jpg";
// import programFestaCont3Img2 from "@/assets/images/user/programFestaCont3Img2.jpg";
// import programFestaCont4Img1 from "@/assets/images/user/programFestaCont4Img1.jpg";
// import programFestaCont4Img2 from "@/assets/images/user/programFestaCont4Img2.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import ProgramLinkBtn from "@/components/user/common/ProgramLinkBtn";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

const programList = [
    {
        title: "인디크래프트",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 19:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교 테크원 1층
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            2026 인디크래프트 대한민국 대표 <br className="block sm:hidden" /> 인디게임들을 만날 수 있는
                            절호의 기회!
                            <br />
                            여름을 즐기는 최고의 방법,
                            <br className="block sm:hidden" /> 지금 바로 전시 공간에 어서오세요
                        </p>
                    </li>
                    <li>
                        <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[420px]">
                                <img src={programFesta2026Cont1Img1} alt="인디크래프트" className="w-full" />
                            </li>
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[420px]">
                                <img src={programFesta2026Cont1Img2} alt="2025년 현장 사진" className="w-full" />
                            </li>
                        </ul>
                    </li>
                </ul>
                <ProgramLinkBtn label="사이트 바로가기" href="https://www.indiecraft.or.kr/" />
            </>
        ),
    },
    {
        title: "일러스타 페스",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        9.11 (금) ~ 9.12 (토) 13:00 ~ 20:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        판교역 북측광장 B
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                    <p className={txtBoxClass}>내용</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        북측광장 B를 가득 채우는 2차 창작
                        <br className="block sm:hidden" /> 마켓 로드와 다양한 무대 프로그램이{" "}
                        <br className="block sm:hidden" />
                        함께 합니다!
                    </p>
                </li>
                <li>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[420px]">
                            <img src={programFesta2026Cont2Img1} alt="일러스타 페스" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[420px]">
                            <img src={programFesta2026Cont2Img2} alt="2025년 현장 사진" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: <p className="flex">한국 서브컬처 공모전</p>,
        // title: "[THE FESTA] 한국 서브컬처 공모전",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                {/* 9.12 (토) 12:00 ~ 15:00 */}
                                9.12 (토) * 시간 추후 공지
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 중앙광장 - 메인 무대
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                캐릭터와 창작이 만나는 서브컬처 <br className="block sm:hidden" />
                                코스프레 댄스 무대음악과 퍼포먼스로 <br />
                                캐릭터를 표현하는 코스프레 댄스 <br className="block sm:hidden" />
                                창작자들의 특별한 무대를 만나보세요.
                            </p>
                        </li>
                    </ul>
                    {/* 로고 PNG 는 배경·테두리가 없으므로, 시안의 420x280 흰 박스(테두리 #DDD)를 CSS 로 만들고
                        그 안에 로고를 가운데 둔다. 로고 폭은 시안 비율 79.65%(420 기준 약 334px). */}
                    <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                        <div className="flex aspect-[420/280] w-full items-center justify-center border border-[#DDD] bg-white">
                            <img src={programFesta2026Cont6Img1} alt="한국 서브컬처 공모전" className="w-[79.65%]" />
                        </div>
                    </div>
                </div>
                <ProgramLinkBtn label="참가신청 바로가기" href="https://x.com/illustar_stage/status/2089620647676870951?s=20" />
            </>
        ),
    },
    {
        title: <p className="flex">AI GSDC</p>,
        // title: "[THE FESTA] AI GSDC : AI Game Sound Design Challenge",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                9.12 (토) 15:30 ~ 16:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 중앙광장 - 메인 무대
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                게임 사운드를 만드는 새로운 방식! <br />
                                AI Game Sound Design <br className="block sm:hidden" />
                                Challenge!!
                                <br />
                                Gamesound.ai와 함께 AI 시대의 <br className="block sm:hidden" />
                                사운드 디자인을 탐험하고, <br />
                                당신만의 사운드로 게임의 세계를 <br className="block sm:hidden" />
                                완성해보세요.
                            </p>
                        </li>
                    </ul>
                    <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                        <img src={programStage2026Cont5Img1} alt="AI GSDC" className="w-full" />
                    </div>
                </div>
                <ProgramLinkBtn label="참가신청 바로가기" href="https://likers.me/gxg/gsdc" />
            </>
        ),
    },
    {
        title: <p className="flex">GV2026</p>,
        // title: "[THE FESTA] GV2026 : GAME VISION 2026",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <div className="flex flex-col gap-[16px] md:gap-[24px]">
                    <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                        <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                            <li className="flex items-center gap-[8px] md:gap-[20px]">
                                <p className={txtBoxClass}>일시</p>
                                <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                    9.11 (금) 13:00 ~ 16:00
                                </p>
                            </li>
                            <li className="flex items-center gap-[8px] md:gap-[20px]">
                                <p className={txtBoxClass}>장소</p>
                                <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                    경기창조경제혁신센터 B2층 <br className="block sm:hidden" />
                                    국제회의장, 7층 별똥별
                                </p>
                            </li>
                            <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                                <p className={txtBoxClass}>내용</p>
                                <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                    게임을 꿈꾸는 청소년과 청년을 위한 GV2026!
                                    <br />
                                    게임 개발부터 e스포츠 직무까지, <br className="block sm:hidden" />
                                    현업 전문가와 함께하는 <br className="block sm:hidden" />
                                    진로 특강 프로그램!
                                </p>
                            </li>
                        </ul>
                        {/* 이미지 파일에 1px #DDD 테두리가 포함돼 있어 CSS border 를 주지 않는다(주면 2겹). */}
                        <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                            <img src={programFesta2026Cont7Img1} alt="GV 2026" className="w-full" />
                        </div>
                    </div>
                    {/* 세션 강연자 판 2장. 하나의 이미지처럼 이어 붙여야 해서 gap 을 주지 않는다.
                        sm 미만에서는 나란히 두면 인물 얼굴이 뭉개질 만큼 좁아져 두 줄로 쌓는다. */}
                    <div className="flex flex-col sm:flex-row">
                        <img
                            src={programFesta2026Cont7Img2}
                            alt="GV2026 SESSION 1 게임·AI 개발 강연자"
                            className="w-full sm:w-1/2"
                        />
                        <img
                            src={programFesta2026Cont7Img3}
                            alt="GV2026 SESSION 2 e스포츠 강연자"
                            className="w-full sm:w-1/2"
                        />
                    </div>
                </div>
                <ProgramLinkBtn
                    label="참가신청 바로가기"
                    href="https://docs.google.com/forms/d/e/1FAIpQLScZdFl01keJnJoYJsbhgVFHiW8c8ZwP6QJSPXARyZaTv0BgxQ/viewform"
                />
            </>
        ),
    },
    {
        title: (
            <p className="flex">
                포켓몬 카드 게임
                <br className="block sm:hidden" /> 2026 성남CITY 배틀 토너먼트
            </p>
        ),
        // title: "[THE FESTA] 포켓몬 카드 게임 '2026 성남CITY 배틀토너먼트'",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[24px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                9. 12(토) 10:30 ~ 종료시 까지
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                현대백화점 판교점 10층 토파즈홀(문화홀)
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                2026 성남CITY 배틀 토너먼트 개최!
                                <br />
                                지역 예선 및 본선 당일 현장 예선<br className="sm:hidden" />(사전예약 필수)을 통과한 참가자들이
                                <br /> 
                                토너먼트 방식으로 최종 우승에 <br className="sm:hidden" />도전합니다!
                                <br />
                                일반 관람객을 대상으로 한 다양한 <br className="sm:hidden" />서브 이벤트도 진행합니다! 

                                {/* 2026 성남CITY 배틀 <br className="block sm:hidden" />
                                토너먼트 개최!
                                <br />
                                지역 예선 및 본선 당일 현장 예선을
                                <br className="block sm:hidden" /> 통과한 참가자들이 토너먼트 방식으로{" "}
                                <br className="block sm:hidden" />
                                최종 우승에 도전합니다!
                                <br />
                                일반 관람객을 대상으로 한 다양한
                                <br className="block sm:hidden" /> 서브 이벤트도 진행합니다! */}
                                {/* <br className="block sm:hidden" /> 누구나 무료로 참가할 수 있습니다. */}
                            </p>
                        </li>
                    </ul>
                    {/* 이미지 파일에 1px #DDD 테두리가 포함돼 있어 CSS border 를 주지 않는다(주면 2겹). */}
                    <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                        <img src={programFesta2026Cont8Img1} alt="2026 성남CITY 배틀 토너먼트" className="w-full" />
                    </div>
                </div>
                <img src={programFesta2026Cont8Img2} alt="2026 성남CITY 배틀 토너먼트 포스터" className="w-full" />
            </div>
        ),
    },
    {
        title: (
            <p className="flex">
                2026 경기게임마이스터고
                <br className="block sm:hidden" /> 졸업 작품 전시회
            </p>
        ),
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9. 10.(목) ~ 11.(금) 10:00 ~ 18:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교 네오위즈 사옥 1층
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            국내 유일 게임 콘텐츠 개발
                            <br />
                            마이스터고 학생들의 개발 실력을 <br className="block sm:hidden" />
                            직접 확인해 보세요!
                        </p>
                    </li>
                </ul>
                {/* 다른 항목의 이미지는 가로형(630x420)이지만 이 포스터만 세로형이라,
                    같은 420 폭 자리에 두되 높이는 원본 비율대로 흐르게 둔다. */}
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img
                        src={programFesta2026Cont9Img1}
                        alt="2026 경기게임마이스터고 졸업 작품 전시회 포스터"
                        className="w-full"
                    />
                </div>
            </div>
        ),
    },
];

/* ===== 2025 콘텐츠(이미지 포함) - 삭제하지 말고 재사용 대비 보존 =====
const programList = [
    {
        title: "인디크래프트",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9.19 (금) ~ 9.20 (토) 13:00 ~ 19:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교테크원 B1, 1F, 판교역 역사
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            2025 인디크래프트&apos; 대한민국 대표 <br className="md:hidden" />
                            인디게임들을 만날 수 있는 절호의 기회! <br />
                            여름을 즐기는 최고의 방법, <br className="md:hidden" />
                            지금 바로 전시 공간에 어서오세요
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont1Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont1Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "일러스타 페스",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9.19 (금) ~ 9.20 (토) 13:00 ~ 20:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 서측광장
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            서측광장을 가득 채우는 <br className="md:hidden" />
                            52개의 2차 창작 마켓 로드와 <br />
                            다양한 무대 프로그램이 함께합니다!
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont2Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont2Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "성남청년 플리마켓",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9.19 (금) ~ 9.20 (토) 13:00 ~ 20:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            GXG 2025에서 만나는 <br className="md:hidden" />
                            성남 로컬 브랜드 마켓! <br />
                            성남청년 플리마켓에서 축제의 <br className="md:hidden" />
                            또다른 재미를 느껴보세요!
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont3Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont3Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "GV2025",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9.19 (금) 13:00 ~ 17:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            경기창조경제혁신센터 B2 국제회의장
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            게임을 좋아하는 마음, <br className="md:hidden" />
                            이제는 진로로 확장할 때! <br />
                            성남시 청소년과 청년을 위한 <br className="md:hidden" />
                            게임진로 탐색 프로그램
                        </p>
                    </li>
                    <li className="flex flex-col gap-[16px] md:gap-[40px]">
                        <div className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>강연자</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                - 원더포션 허유지 산나비 메인 아티스트 <br className="md:hidden" />
                                &lt;대학 다니며 인디게임 출시하기&gt;
                                <br />
                                - 마이크로소프트 한국 게임사업부 김지선 선임 영업대표 <br className="xl:hidden" />
                                &lt;비전공자의 커리어 퀘스트: 게임회사에서 마이크로소프트까지, 그리고 AI 이야기 &gt;
                                <br />
                                - 슈퍼셀 이욱진 클래시로얄 서버 개발자 <br className="md:hidden" />
                                &lt;실시간 대전 서버를 위한 넓고 얇은 지식 &gt;
                                <br />- 엔씨소프트 장현영 상무 <br className="md:hidden" />
                                &lt;직업인으로서의 게임, 그리고 게임인 &gt;
                            </p>
                        </div>
                        <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programFestaCont4Img1} alt="이미지" className="w-full" />
                            </li>
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programFestaCont4Img2} alt="이미지" className="w-full" />
                            </li>
                        </ul>
                    </li>
                </ul>
                <a
                    href="https://forms.gle/vYJiSuxRnbzeG1aS8"
                    target="_blank"
                    rel="noreferrer"
                    className="m-[20px_auto_0] relative block w-full h-[72px] text-white text-[20px] text-center leading-[70px] font-['GongGothicMedium'] clip-path-octagon border border-black bg-black max-w-[320px]"
                >
                    <span>GV2025 참가 신청하기</span>
                    <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                    <span className="absolute left-0 bottom-0 border-[8px] border-black border-t-transparent border-r-transparent" />
                    <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                    <span className="absolute right-0 bottom-0 border-[8px] border-black border-t-transparent border-l-transparent" />
                </a>
            </>
        ),
    },
];
===== 2025 콘텐츠 보존 끝 ===== */

export default function Festa() {
    return (
        <>
            <div className="p-[48px_0_20px] font-['GongGothicLight'] text-[12px] md:text-[18px] xl:pt-[60px] xl:text-right xl:text-[24px]">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                hideItemBorder
            />
        </>
    );
}
